<eda-dialog2 width="80vw" height="80vh" [header]="title" (apply)="saveChartConfig()" (close)="closeChartConfig()" [disableApply]="!thresholdsValid">
  <div content class="flex flex-col md:flex-row flex-1 overflow-hidden h-[70vh]">
    <!-- Chart Preview -->
    <div class="flex-1 flex justify-center border-b md:border-b-0 md:border-r bg-slate-50" >
      <div class="relative" [ngClass]="this.controller.params.chart.edaChart === 'radar' ? 'w-[30vw]' : 'p-3 pb-6 h-full w-full content-end'">
        @if (display) {
          <panel-chart #PanelChartComponent [props]="panelChartConfig" class="h-[95%] w-full block"></panel-chart>
        }
      </div>
    </div>

    <!-- Settings -->
    <div class=" flex-1 h-[95%] overflow-y-auto pl-6">
      <!-- Display Tab -->
      <div class="space-y-6 p-4 pt-0 mb-6 bg-slate-50 rounded-md">
        <div class="space-y-4">
          <span class="text-lg font-semibold" i18n="@@chartDisplayOptionsTitle">
            Opciones de visualización
          </span>

          <div class="space-y-4 text-base gap-3 flex flex-col">
            @if (panelChartConfig.edaChart !== 'histogram') {
            <!-- Tendencia -->
            @if (showTrend) {
            <div class="flex items-center justify-between">
              <div class="space-y-0.5">
                <div class="flex items-center gap-2">
                  <label i18n="@@addtrend" for="tendencia" class="font-medium">
                    Tendencia
                  </label>
                  <div class="relative group">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="text-slate-400">
                      <circle cx="12" cy="12" r="10"></circle>
                      <path d="M12 16v-4"></path>
                      <path d="M12 8h.01"></path>
                    </svg>
                    <div
                      class="absolute left-full top-1/2 transform -translate-y-1/2 ml-2 w-60 eda-tooltip-popup opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity">
                      <span i18n="@@chartTrendOption">Mostrar línea de tendencia en el gráfico</span>
                    </div>
                  </div>
                </div>
              </div>
              <label class="relative inline-flex items-center" [class.toggle-blocked]="addComparative" [attr.data-tooltip]="addComparative ? tooltipBlockedByComparative : null">
                <input type="checkbox" [(ngModel)]="addTrend" class="sr-only peer" (ngModelChange)="checkTrend()" [disabled]="addComparative">
                <div 
                  class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-[var(--corporate-primary)] rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[var(--corporate-primary)]">
                </div>
              </label>
            </div>
            }

            <!-- Comparativa -->
            @if (showComparative) {
            <div class="flex items-center justify-between">
              <div class="space-y-0.5">
                <div class="flex items-center gap-2">
                  <label i18n="@@addComparative" for="comparativa" class="font-medium">
                    Comparativa
                  </label>
                  <div class="relative group">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="text-slate-400">
                      <circle cx="12" cy="12" r="10"></circle>
                      <path d="M12 16v-4"></path>
                      <path d="M12 8h.01"></path>
                    </svg>
                    <div
                      class="absolute left-full top-1/2 transform -translate-y-1/2 ml-2 w-60 eda-tooltip-popup opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity">
                      <span i18n="@@chartComparationOption">Habilita la comparación con períodos anteriores</span>
                    </div>
                  </div>
                </div>
              </div>
              <label class="relative inline-flex items-center" [class.toggle-blocked]="addTrend || showPredictionLines" [attr.data-tooltip]="(addTrend || showPredictionLines) ? tooltipBlockedByTrendOrPrediction : null">
                <input type="checkbox" [(ngModel)]="addComparative" class="sr-only peer"
                  (ngModelChange)="setComparative()" [disabled]="addTrend || showPredictionLines">
                <div 
                  class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-[var(--corporate-primary)] rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[var(--corporate-primary)]">
                </div>
              </label>
            </div>
            }
            }
            
            <!-- Mostrar Leyenda -->
            <div class="flex items-center justify-between">
              <div class="space-y-0.5">
                <div class="flex items-center gap-2">
                  <label i18n="@@showLegend" for="mostrarLeyenda" class="font-medium">
                    Mostrar Leyenda
                  </label>
                  <div class="relative group">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="text-slate-400">
                      <circle cx="12" cy="12" r="10"></circle>
                      <path d="M12 16v-4"></path>
                      <path d="M12 8h.01"></path>
                    </svg>
                    <div
                      class="absolute left-full top-1/2 transform -translate-y-1/2 ml-2 w-60 eda-tooltip-popup opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity">
                      <span i18n="@@chartLegendOptionDescription">Muestra la leyenda del gráfico</span>
                    </div>
                  </div>
                </div>
              </div>
              <label class="relative inline-flex items-center cursor-pointer">
                <input type="checkbox" [(ngModel)]="chartLegend" class="sr-only peer" (ngModelChange)="setChartLegend()">
                <div
                  class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-[var(--corporate-primary)] rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[var(--corporate-primary)]">
                </div>
              </label>
            </div>
            
            <!-- Mostrar Líneas Guía -->
            @if (['bar', 'horizontalBar', 'line', 'area', 'kpiarea', 'polarArea'].includes(panelChartConfig.edaChart)) {
            <div class="flex items-center justify-between">
              <div class="space-y-0.5">
                <div class="flex items-center gap-2">
                  <label i18n="@@showGridLines" for="mostrarLineasGuia" class="font-medium">
                    Mostrar Líneas Guía
                  </label>
                  <div class="relative group">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="text-slate-400">
                      <circle cx="12" cy="12" r="10"></circle>
                      <path d="M12 16v-4"></path>
                      <path d="M12 8h.01"></path>
                    </svg>
                    <div
                      class="absolute left-full top-1/2 transform -translate-y-1/2 ml-2 w-60 eda-tooltip-popup opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity">
                      <span i18n="@@chartGridLinesOptionDescription">Muestra u oculta las líneas guía del gráfico</span>
                    </div>
                  </div>
                </div>
              </div>
              <label class="relative inline-flex items-center cursor-pointer">
                <input type="checkbox" [(ngModel)]="showGridLines" class="sr-only peer" (ngModelChange)="setShowGridLines()">
                <div
                  class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-[var(--corporate-primary)] rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[var(--corporate-primary)]">
                </div>
              </label>
            </div>
            }

            <!-- Mostrar Etiquetas -->
            <div class="flex items-center justify-between">
              <div class="space-y-0.5">
                <div class="flex items-center gap-2">
                  <label i18n="@@showLabels" for="mostrarEtiquetas" class="font-medium">
                    Mostrar Etiquetas
                  </label>
                  <div class="relative group">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="text-slate-400">
                      <circle cx="12" cy="12" r="10"></circle>
                      <path d="M12 16v-4"></path>
                      <path d="M12 8h.01"></path>
                    </svg>
                    <div
                      class="absolute left-full top-1/2 transform -translate-y-1/2 ml-2 w-60 eda-tooltip-popup opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity">
                      <span i18n="@@chartLabelOption">Muestra etiquetas con valores en el gráfico</span>
                    </div>
                  </div>
                </div>
              </div>
              <label class="relative inline-flex items-center cursor-pointer">
                <input type="checkbox" [(ngModel)]="showLabels" class="sr-only peer" (ngModelChange)="setShowLables()">
                <div
                  class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-[var(--corporate-primary)] rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[var(--corporate-primary)]">
                </div>
              </label>
            </div>

            <!-- Mostrar Etiquetas Porcentaje -->
            <div class="flex items-center justify-between">
              <div class="space-y-0.5">
                <div class="flex items-center gap-2">
                  <label i18n="@@showLabelsPercent" for="mostrarEtiquetasPorcentaje" class="font-medium">
                    Etiquetas en Porcentaje
                  </label>
                  <div class="relative group">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="text-slate-400">
                      <circle cx="12" cy="12" r="10"></circle>
                      <path d="M12 16v-4"></path>
                      <path d="M12 8h.01"></path>
                    </svg>
                    <div
                      class="absolute left-full top-1/2 transform -translate-y-1/2 ml-2 w-60 eda-tooltip-popup opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity">
                      <span i18n="@@chartLabelPercentOption">Muestra etiquetas en formato porcentaje</span>
                    </div>
                  </div>
                </div>
              </div>
              <label class="relative inline-flex items-center cursor-pointer">
                <input type="checkbox" [(ngModel)]="showLabelsPercent" class="sr-only peer" (ngModelChange)="setShowLablesPercent()">
                <div
                  class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-[var(--corporate-primary)] rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[var(--corporate-primary)]">
                </div>
              </label>
            </div>
            
            <!-- Número de Columnas (solo histograma) -->
            @if (showNumberOfColumns) {
            <div class="flex items-center justify-between">
              <div class="space-y-0.5">
                <div class="flex items-center gap-2">
                  <label i18n="@@histogramColum" for="numberOfColumns" class="font-medium">
                    Columnas
                  </label>
                  <div class="relative group">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="text-slate-400">
                      <circle cx="12" cy="12" r="10"></circle>
                      <path d="M12 16v-4"></path>
                      <path d="M12 8h.01"></path>
                    </svg>
                    <div
                      class="absolute left-full top-1/2 transform -translate-y-1/2 ml-2 w-60 eda-tooltip-popup opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity">
                      <span>{{ columnsTooltip }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <input type="number" id="numberOfColumns" name="numberOfColumns"
                min="3" max="100" [(ngModel)]="numberOfColumns" (change)="SetNumberOfColumns()"
                class="w-20 rounded-md border border-input bg-background px-3 py-2 text-sm">
            </div>
            }

            <!-- Activar Colores Únicos -->
            @if ((panelChartConfig.edaChart === 'bar' || panelChartConfig.edaChart === 'horizontalBar') && queryNumericColumns.length === 1) {
              <div class="flex items-center justify-between">
                <div class="space-y-0.5">
                  <div class="flex items-center gap-2">
                    <label i18n="@@showUniqueColors" for="activarColoresUnicos" class="font-medium">
                      Activar Colores Únicos
                    </label>
                    <div class="relative group">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="text-slate-400">
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="M12 16v-4"></path>
                        <path d="M12 8h.01"></path>
                      </svg>
                      <div
                        class="absolute left-full top-1/2 transform -translate-y-1/2 ml-2 w-60 eda-tooltip-popup opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity">
                        <span i18n="@@chartUniqueColorsOption">Asigna un color único a cada barra o elemento</span>
                      </div>
                    </div>
                  </div>
                </div>
                <label class="relative inline-flex items-center cursor-pointer">
                  <input type="checkbox" [(ngModel)]="showUniqueColors" class="sr-only peer" (ngModelChange)="setShowUniqueColors()">
                  <div
                    class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-[var(--corporate-primary)] rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[var(--corporate-primary)]">
                  </div>
                </label>
              </div>
            }

            <!-- Opciones adicionales para Line charts -->
            @if (showTrend) {
            <div class="flex items-center justify-between">
              <div class="space-y-0.5">
                <div class="flex items-center gap-2">
                  <label i18n="@@showLines" class="font-medium">
                    Mostrar Líneas de Puntos
                  </label>
                  <div class="relative group">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="text-slate-400">
                      <circle cx="12" cy="12" r="10"></circle>
                      <path d="M12 16v-4"></path>
                      <path d="M12 8h.01"></path>
                    </svg>
                    <div
                      class="absolute left-full top-1/2 transform -translate-y-1/2 ml-2 w-60 eda-tooltip-popup opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity">
                      <span i18n="@@chartLabelLineOptionDescription">Muestra líneas conectando los puntos</span>
                    </div>
                  </div>
                </div>
              </div>
              <label class="relative inline-flex items-center cursor-pointer">
                <input type="checkbox" [(ngModel)]="showPointLines" class="sr-only peer"
                  (ngModelChange)="setShowLines()">
                <div
                  class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-[var(--corporate-primary)] rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[var(--corporate-primary)]">
                </div>
              </label>
            </div>

            <div class="flex items-center justify-between">
              <div class="space-y-0.5">
                <div class="flex items-center gap-2">
                  <label i18n="@@showLinesPrediction" class="font-medium">
                    Mostrar Predicción
                  </label>
                  <div class="relative group">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="text-slate-400">
                      <circle cx="12" cy="12" r="10"></circle>
                      <path d="M12 16v-4"></path>
                      <path d="M12 8h.01"></path>
                    </svg>
                    <div
                      class="absolute left-full top-1/2 transform -translate-y-1/2 ml-2 w-60 eda-tooltip-popup opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity">
                      <span i18n="@@chartLabelLinePredictionOptionDescription">Muestra la predicción de la serie</span>
                    </div>
                  </div>
                </div>
              </div>
              <label class="relative inline-flex items-center" [class.toggle-blocked]="addComparative" [attr.data-tooltip]="addComparative ? tooltipBlockedByComparative : null">
                <input type="checkbox" [(ngModel)]="showPredictionLines" class="sr-only peer"
                  (ngModelChange)="setPredictionLines()" [disabled]="addComparative">
                <div 
                  class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-[var(--corporate-primary)] rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[var(--corporate-primary)]">
                </div>
              </label>
            </div>

            }
          </div>
        </div>
      </div>
      
      <!-- Sección de Colores -->
      <div class="space-y-6 p-4 pt-0 bg-slate-50 rounded-md">
        <div class="space-y-4">
          <span class="text-lg font-semibold" i18n="@@colorsChartH6">
            Colores
          </span>
          @if (panelChartConfig.edaChart !== 'bar' && panelChartConfig.edaChart !== 'horizontalBar') {
            <div>
              <div class="grid gap-4 grid-rows-auto gap-6">
                <div>
                  <h6 i18n="@@ChangeDefaultsColors" class="mb-1">Color de los gráficos:</h6>
                    <div class="flex items-stretch gap-2 mb-6">
                      <p-dropdown
                        [(ngModel)]="selectedPalette"
                        [options]="allPalettes"
                        optionLabel="name"
                        i18n-placeholder="@@selectPalette"
                        placeholder="-- Seleccione una paleta --"
                        (ngModelChange)="onPaletteSelected()"
                        [style]="{'width':'180px'}"
                        appendTo="body">
                      </p-dropdown>
                      @if (selectedPalette) {
                        <div class="flex rounded overflow-hidden" style="width: 80px;">
                          @for (color of selectedPalette.paleta.slice(0, 8); track $index) {
                            <div class="flex-1" [style.background-color]="color"></div>
                          }
                        </div>
                      }
                    </div>
  
                    <!-- Iterar sobre assignedColors -->
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                      @for (color of assignedColors; track color.value; let idx = $index) {
                        <div class="flex flex-col gap-2 border rounded-lg p-3 bg-white hover:bg-slate-50">
                          <div class="flex items-center justify-between">
                            <span class="font-medium">{{ color.value }}</span>
                            <div class="flex items-center gap-2">
                              <input
                                [(ngModel)]="assignedColors[idx].color"
                                (input)="handleInputColor()"
                                class="text-md text-slate-500 font-mono w-[3.5vw]"
                              >
                              <p-colorPicker
                                [(ngModel)]="assignedColors[idx].color"
                                (onChange)="handleInputColor()"
                                format="hex"
                                appendTo="body"
                              />
                            </div>
                          </div>
                          @if (isAreaOrRadarChart) {
                            <div class="flex items-center gap-2">
                              <label class="text-xs text-slate-500 w-16 shrink-0" i18n="@@opacityLabel">Opacidad</label>
                              <!-- <input type="range" min="0" max="100" step="1"
                                [(ngModel)]="assignedColors[idx].opacity"
                                (input)="handleInputColor()"
                                class="flex-1 accent-[#00bcd4]">
                              <span class="text-xs text-slate-500 w-8 text-right">{{ assignedColors[idx].opacity ?? 100 }}%</span> -->
                              <input type="number" min="0" max="100" step="1"
                                [(ngModel)]="assignedColors[idx].opacity"
                                (input)="handleInputColor()"
                                class="text-xs text-slate-500 font-mono w-14 border rounded px-1 text-right">
                              <span class="text-xs text-slate-500">%</span>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }  
            @else{
              <p-tabView [(activeIndex)]="activeTabIndex" (onChange)="onTabChange($event)">
                <p-tabPanel header="Colores" i18n-header="@@colorsTab">
                  <div class="grid p-6 gap-4 grid-rows-auto gap-6">
                    <div>
                      @if (!showUniqueColors) {
                        <h6 i18n="@@ChangeDefaultsColors" class="mb-1">Color de los gráficos:</h6>
                        <div class="flex items-stretch gap-2 mb-6">
                          <p-dropdown
                            [(ngModel)]="selectedPalette"
                            [options]="allPalettes"
                            optionLabel="name"
                            i18n-placeholder="@@selectPalette"
                            placeholder="-- Seleccione una paleta --"
                            (ngModelChange)="onPaletteSelected()"
                            [style]="{'width':'180px'}"
                            appendTo="body">
                          </p-dropdown>
                          @if (selectedPalette) {
                            <div class="flex rounded overflow-hidden" style="width: 80px;">
                              @for (color of selectedPalette.paleta.slice(0, 8); track $index) {
                                <div class="flex-1" [style.background-color]="color"></div>
                              }
                            </div>
                          }
                        </div>
                        <!-- Iterar sobre assignedColors (un color por serie) -->
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                          @for (color of assignedColors; track color.value; let idx = $index) {
                          <div class="flex items-center justify-between border rounded-lg p-3 bg-white hover:bg-slate-50">
                            <span class="font-medium">{{ color.value }}</span>
                            <div class="flex items-center gap-2">
                              <input [(ngModel)]="assignedColors[idx].color" (input)="handleInputColor()" class="text-md text-slate-500 font-mono w-[3.5vw]">
                              <p-colorPicker [(ngModel)]="assignedColors[idx].color" (onChange)="handleInputColor()" format="hex" appendTo="body" />
                            </div>
                          </div>
                          }
                        </div>
                      }
                      @else {
                        <!-- Colores únicos por label/barra -->

                        <h6 i18n="@@ChangeDefaultsColors" class="mb-1">Color de los gráficos:</h6>
                        <div class="flex items-stretch gap-2 mb-6">
                          <p-dropdown
                            [(ngModel)]="selectedPalette"
                            [options]="allPalettes"
                            optionLabel="name"
                            i18n-placeholder="@@selectPalette"
                            placeholder="-- Seleccione una paleta --"
                            (ngModelChange)="onPaletteSelected()"
                            [style]="{'width':'180px'}"
                            appendTo="body">
                          </p-dropdown>
                          @if (selectedPalette) {
                            <div class="flex rounded overflow-hidden" style="width: 80px;">
                              @for (color of selectedPalette.paleta.slice(0, 8); track $index) {
                                <div class="flex-1" [style.background-color]="color"></div>
                              }
                            </div>
                          }
                        </div>

                        @if (uniqueBarColors.length === 0) {
                          <p class="text-sm text-slate-400 italic" i18n="@@noUniqueLabels">No hay valores únicos disponibles.</p>
                        }
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                          @for (color of uniqueBarColors; track color.value; let idx = $index) {
                          <div class="flex items-center justify-between border rounded-lg p-3 bg-white hover:bg-slate-50">
                            <span class="font-medium truncate max-w-[60%]" [title]="color.value">{{ color.value }}</span>
                            <div class="flex items-center gap-2">
                              <input [(ngModel)]="uniqueBarColors[idx].color" (input)="handleUniqueColorInput()" class="text-md text-slate-500 font-mono w-[3.5vw]">
                              <p-colorPicker [(ngModel)]="uniqueBarColors[idx].color" (onChange)="handleUniqueColorInput()" format="hex" appendTo="body" />
                            </div>
                          </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </p-tabPanel>
                <p-tabPanel header="Colores por intervalo" i18n-header="@@gradientTab">
                  <div class="px-6 pb-4">

                    <div class="chart-color-selection mt-4" style="min-width: 300px;">
                      <div class="flex items-center justify-between border rounded-lg p-3 hover:bg-slate-50">
                        <div>
                          <span class="font-medium mr-4">{{coloredBarsColumnHeader}} <span i18n="@@aboveThreshold">es mayor que:</span></span>
                          <p-inputNumber [(ngModel)]="thresholdHigh" mode="decimal" (onInput)="applyColoredBars()"
                          [minFractionDigits]="0" [maxFractionDigits]="4"
                          [ngClass]="{'ng-invalid ng-dirty': !thresholdsValid}" />
                        </div>
                        <div class="flex items-center gap-2">
                          <input class="text-md text-right text-slate-500 font-mono" [(ngModel)]="colorAbove" (input)="applyColoredBars()">
                          <p-colorPicker [(ngModel)]="colorAbove" format="hex" appendTo="body" (onChange)="applyColoredBars()" />
                        </div>
                      </div>
                    </div>
  
                    <div class="chart-color-selection mt-4" style="min-width: 300px;">
                      <div class="flex items-center justify-between border rounded-lg p-3 hover:bg-slate-50">
                        <span class="font-medium">{{coloredBarsColumnHeader}} <span i18n="@@betweenThresholds">mayor que</span> {{thresholdLow}} <span i18n="@@betweenThresholds2">y menor que</span> {{thresholdHigh}}</span>
                        <div class="flex items-center gap-2">
                          <input class="text-md text-right text-slate-500 font-mono" [(ngModel)]="colorBetween" (input)="applyColoredBars()">
                          <p-colorPicker [(ngModel)]="colorBetween" format="hex" appendTo="body" (onChange)="applyColoredBars()" />
                        </div>
                      </div>
                    </div>
  
                    <div class="chart-color-selection mt-4" style="min-width: 300px;">
                      <div class="flex items-center justify-between border rounded-lg p-3 hover:bg-slate-50">
                        <div>
                          <span class="font-medium mr-4">{{coloredBarsColumnHeader}} <span i18n="@@belowThreshold">es menor que:</span></span>
                          <p-inputNumber [(ngModel)]="thresholdLow" mode="decimal" (onInput)="applyColoredBars()"
                          [minFractionDigits]="0" [maxFractionDigits]="4"
                          [ngClass]="{'ng-invalid ng-dirty': !thresholdsValid}" />
                        </div>
                        <div class="flex items-center gap-2">
                          <input class="text-md text-right text-slate-500 font-mono" [(ngModel)]="colorBelow" (input)="applyColoredBars()">
                          <p-colorPicker [(ngModel)]="colorBelow" format="hex" appendTo="body" (onChange)="applyColoredBars()" />
                        </div>
                      </div>
                    </div>
                  </div>
                </p-tabPanel>
              </p-tabView>
            }
        </div>
      </div>
    </div>
  </div>
</eda-dialog2>

<!-- Prediction Configuration Dialog -->
@if (showPredictionDialog) {
  <app-prediction-dialog
    [(visible)]="showPredictionDialog" [predictionMethod]="predictionMethod" [queryColumns]="queryNumericColumns" (confirm)="confirmPrediction($event)" (cancel)="cancelPrediction()">
  </app-prediction-dialog>
}
